/* TODO: t() */
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import FormFieldEditor from '../helpers/FormFieldEditor';
import isPrimitive from '../../../../support/helpers/isPrimitive';
import Dropdown from '../../../uiold/Dropdown';
import { Checkbox, Text } from '../../../uiold';

import BooleanElement from '../BooleanElement';

type EditorViewProps = {
  data: {
    [key: string]: unknown;
  };
  updateValue: (key: string, newValue: unknown) => void;
  renderNameInput: () => ReactElement;
  renderLabelInput: () => ReactElement;
};

const defaultValueOptions = [
  { id: 0, name: 'No', value: false },
  { id: 1, name: 'Yes', value: true },
];

function EditorView(props: EditorViewProps) {
  let { data, updateValue, renderNameInput, renderLabelInput } = props;
  let onOptionChange = (option: { value: string }) => {
    // hacky: `option` can be an object (`id`, `name`, `value`) or a string.
    // TODO: Is this needed?
    let value = isPrimitive(option) ? option : option.value;
    updateValue('default_value', value);
  };
  let defaultValue = defaultValueOptions[data.default_value ? 1 : 0];
  return (
    <View>
      {renderNameInput()}
      {renderLabelInput()}
      <Text accessibilityRole="label" style={styles.label}>
        <Text style={styles.defaultText}>Default Answer</Text>
        <Dropdown
          value={defaultValue}
          options={defaultValueOptions}
          onChange={onOptionChange}
        />
      </Text>
      <View>
        <Checkbox
          text="Use Checkbox"
          isChecked={!!data.use_checkbox}
          onChange={(value) => updateValue('use_checkbox', value)}
        />
        <Checkbox
          text=" Require Acceptance"
          isChecked={!!data.require_acceptance}
          onChange={(value) => updateValue('require_acceptance', value)}
        />
      </View>
    </View>
  );
}

type Props = {
  parent: BooleanElement;
};

class BooleanElementFieldEditorView extends Component<Props> {
  render() {
    let { parent } = this.props;
    return <FormFieldEditor component={EditorView} parent={parent} />;
  }
}

let styles = StyleSheet.create({
  label: {
    paddingVertical: 10,
  },
  defaultText: {
    marginRight: 10,
  },
});

export default BooleanElementFieldEditorView;
